import { RequestCapability } from '../core/request-capability.js';
/**
 * Involves the given `middleware` into HTTP request processing.
 *
 * @typeParam TInput - A type of input HTTP request processing means.
 * @param middleware - Middleware to apply.
 *
 * @returns New request processing capability that processes HTTP requests by the given `middleware`.
 */
export function middleware(middleware) {
    return RequestCapability.of(middlewareProvider);
    function middlewareProvider(handler) {
        return async ({ request, response, next }) => await new Promise((resolve, reject) => {
            const mdNext = (error) => {
                if (error !== undefined) {
                    reject(error);
                }
                else {
                    next(handler).then(() => resolve(), reject);
                }
            };
            middleware(request, response, mdNext);
        });
    }
}
//# sourceMappingURL=middleware.js.map